<section class="view-container">
    <div class="personal-container">
        <h1 class="personal-heading">{{'ACCOUNT.PERSONAL_INFORMATION.HEADING' | translateIt: {language:
            sharedService.currentLanguage} |async}}</h1>
        <div class="personal-text-container">
            <div class="row row-spacing">
                <div class="col-md-6">
                    <app-custom-input
                        [label]="'ACCOUNT.PERSONAL_INFORMATION.WOW_ID' | translateIt: {language:sharedService.currentLanguage} |async "
                        [inputControl]="profile_form.get(['profile','wowId'])"  [inputStyle]="inputStyle" [type]="'string'" class="grow-class"
                        [readOnly]="true" />
                </div>
                <div class="col-md-6">
                    <app-custom-input
                        [label]="'ACCOUNT.PERSONAL_INFORMATION.NAME' | translateIt: {language:sharedService.currentLanguage} |async "
                        [inputControl]="profile_form.get(['profile','displayName'])" [inputStyle]="inputStyle" [type]="'string'" class="grow-class"
                        [readOnly]="true" />
                </div>
            </div>
            <div class="row row-spacing">
                <div class="col-md-6">
                    <app-custom-input
                        [label]="'ACCOUNT.PERSONAL_INFORMATION.EMAIL' | translateIt: {language:sharedService.currentLanguage} |async "
                        [inputControl]="profile_form.get(['profile','email'])" [inputStyle]="inputStyle" [type]="'string'" class="grow-class"
                        [readOnly]="true" />
                </div>
                <div class="col-md-6">
                    <app-custom-input
                        [label]="'ACCOUNT.PERSONAL_INFORMATION.PHONE_NUMBER' | translateIt: {language:sharedService.currentLanguage} |async "
                        [inputControl]="profile_form.get(['profile','phoneMobile'])" [type]="'string'" (onPhoneInput) = onPhoneInput($event)
                        class="grow-class" [inputStyle]="inputStyle" [maxLength]="'10'" />
                    <app-error-log
                        [errorMessage1]='"ACCOUNT.ERROR.GENERIC" | translateIt: {language:sharedService.currentLanguage} |async '
                        [errorMessage2]="'PROFILE.ERROR.TOTAL_PHONE_LENGTH' | translate"
                        validation2="minlength"
                        [errorMessage3]="'PROFILE.ERROR.TOTAL_PHONE_LENGTH' | translate"
                        validation3="maxlength"
                        validation1="required" [control]="profile_form.get(['profile','phoneMobile'])"></app-error-log>
                </div>
            </div>
            <div class="row row-spacing">
                <div class="col-md-6">
                    <app-custom-input
                        [label]='"ACCOUNT.PERSONAL_INFORMATION.DATE_OF_BIRTH"  | translateIt: {language:sharedService.currentLanguage} |async'
                        [inputControl]="profile_form.get(['profile','dateOfBirth'])" placeholder="MM-DD-YYY" type="text"
                        [mask]="MASKS.date_of_birth" [readOnly]="true" />
                    <span>MM-DD-YYY</span>
                </div>
                <div class="col-md-6">
                    <app-custom-dropdown [data]="genderData"
                        [label]='"ACCOUNT.PERSONAL_INFORMATION.GENDER"  | translateIt: {language:sharedService.currentLanguage} |async '
                        selectAttribute="value" displayAttribute="name" controlName="gender"
                        [inputControl]="profile_form.get(['profile','gender'])" />
                </div>
            </div>
        </div>
    </div>
    <div class="personal-container">
        <h1 class="personal-heading">{{'ACCOUNT.ADDRESS_DETAIL.HEADING' | translateIt: {language:
            sharedService.currentLanguage} |async}}</h1>
        <div class="personal-text-container">
            <div class="row row-spacing">
                <div class="col-md-6">
                    <app-custom-input
                        [label]="'ACCOUNT.ADDRESS_DETAIL.ADDRESS' | translateIt: {language:sharedService.currentLanguage} |async "
                        [inputControl]="profile_form.get(['address','addressLine1'])" [inputStyle]="inputStyle" [type]="'string'"
                        class="grow-class" />
                    <app-error-log
                        [errorMessage1]='"ACCOUNT.ERROR.GENERIC" | translateIt: {language:sharedService.currentLanguage} |async '
                        validation1="required"
                    [control]="profile_form.get(['address','addressLine1'])"></app-error-log>
                </div>
                <div class="col-md-6">
                    <app-custom-input
                        [label]="'ACCOUNT.ADDRESS_DETAIL.CITY' | translateIt: {language:sharedService.currentLanguage} |async "
                        [inputControl]="profile_form.get(['address','city'])" [inputStyle]="inputStyle" [type]="'string'" class="grow-class" />
                    <app-error-log
                        [errorMessage1]='"ACCOUNT.ERROR.GENERIC" | translateIt: {language:sharedService.currentLanguage} |async '
                        validation1="required" [control]="profile_form.get(['address','city'])"></app-error-log>
                </div>
            </div>
            <div class="row row-spacing">
                <div class="col-md-6">
                    <!-- <app-custom-input
                        [label]="'ACCOUNT.ADDRESS_DETAIL.STATE' | translateIt: {language:sharedService.currentLanguage} |async "
                        [inputControl]="profile_form.get(['address','state'])" [inputStyle]="inputStyle" [type]="'string'" class="grow-class" /> -->
                    <app-custom-dropdown [data]="allStates"
                        [label]='"ACCOUNT.ADDRESS_DETAIL.STATE"  | translateIt: {language:sharedService.currentLanguage} |async '
                        selectAttribute="stateId" displayAttribute="stateName" controlName="stateId"
                        [inputControl]="profile_form.get(['address','stateId'])" />    
                    <app-error-log
                        [errorMessage1]='"ACCOUNT.ERROR.GENERIC" | translateIt: {language:sharedService.currentLanguage} |async '
                        validation1="required" [control]="profile_form.get(['address','stateId'])"></app-error-log>
                </div>
                <div class="col-md-6">
                    <app-custom-input
                        [label]="'ACCOUNT.ADDRESS_DETAIL.ZIP_CODE' | translateIt: {language:sharedService.currentLanguage} |async "
                        [inputControl]="profile_form.get(['address','zipCode'])" [inputStyle]="inputStyle" [maxLength]="'5'" [type]="'string'" class="grow-class" />
                    <app-error-log
                        [errorMessage1]='"ACCOUNT.ERROR.GENERIC" | translateIt: {language:sharedService.currentLanguage} |async '
                        [errorMessage2]='"ACCOUNT.ERROR.ZIP_CODE" | translateIt: {language:sharedService.currentLanguage} |async '
                        validation1="required" validation2="minlength" [control]="profile_form.get(['address','zipCode'])"></app-error-log>
                    
                </div>
            </div>
            <div class="row row-spacing">
                <div class="col-md-6">
                    <app-custom-input
                        [label]="'ACCOUNT.ADDRESS_DETAIL.COUNTRY' | translateIt: {language:sharedService.currentLanguage} |async "
                        [inputControl]="profile_form.get(['address','country'])" [inputStyle]="inputStyle" [type]="'string'" class="grow-class" />
                    <app-error-log
                        [errorMessage1]='"ACCOUNT.ERROR.GENERIC" | translateIt: {language:sharedService.currentLanguage} |async '
                        validation1="required" [control]="profile_form.get(['address','country'])"></app-error-log>
                </div>
                <div class="col-md-6">
                    <app-custom-dropdown [data]="timezoneData"
                        [label]='"ACCOUNT.ADDRESS_DETAIL.TIMEZONE"  | translateIt: {language:sharedService.currentLanguage} |async '
                        selectAttribute="timeZone" displayAttribute="timeZone" controlName="timeZone"
                        [inputControl]="profile_form.get(['address','timeZone'])" />
                </div>
            </div>
        </div>
    </div>
    <div class="btn-container">
        <button class="discard" (click)="toggleEdit.emit()">
            <a>{{'ACCOUNT.BUTTON.DISCARD' | translateIt: {language:
                sharedService.currentLanguage} |async}}</a>
        </button>
        <!-- <button class="save" [ngClass]="{ 'btn-loading': isLoading }" (click)="editMemberProfile($event)">
            <a>{{'ACCOUNT.BUTTON.SAVE' | translateIt: {language:
                sharedService.currentLanguage} |async}}</a>
        </button> -->
         <button
            [disabled]="isLoading"
            (click)="editMemberProfile($event)"
              class="btn btn-primary search-btn save"
            >
          @if(!isLoading){
            {{'ACCOUNT.BUTTON.SAVE' | translateIt: {language:
                sharedService.currentLanguage} |async}}
               
            }

            @else { 
              <div class="spinner-border" role="status"></div> 
            }
        </button>

    </div>
</section>